var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.665,
    height: 37.665,
    viewBox: "0 0 37.665 37.665",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Pen",
    transform: "translate(0 -0.879)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Pfad_128",
    d: "M17.027,4.49a1.7,1.7,0,0,1,.2,3.393l-.2.012H5.108A1.7,1.7,0,0,0,3.417,9.4l-.012.2V33.436a1.7,1.7,0,0,0,1.5,1.691l.2.012H28.945a1.7,1.7,0,0,0,1.691-1.5l.012-.2V21.517a1.7,1.7,0,0,1,3.393-.2l.012.2V33.436a5.108,5.108,0,0,1-4.809,5.1l-.3.008H5.108a5.108,5.108,0,0,1-5.1-4.809L0,33.436V9.6A5.108,5.108,0,0,1,4.809,4.5l.3-.008ZM28.593,2.435a5.314,5.314,0,0,1,7.516,7.516h0L19.933,26.126a1.7,1.7,0,0,1-.792.448h0l-6.811,1.7a1.7,1.7,0,0,1-2.064-2.065h0l1.7-6.811a1.7,1.7,0,0,1,.448-.792h0ZM33.7,4.843a1.909,1.909,0,0,0-2.7,0h0L15.166,20.678l-.9,3.6,3.6-.9L33.7,7.542A1.909,1.909,0,0,0,33.849,5h0Z",
    transform: "translate(0 0)",
    fill: "#4a4a4a"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPen);
export default __webpack_public_path__ + "static/media/pen.4819416137ba37e4bee30e981bb4be98.svg";
export { ForwardRef as ReactComponent };